import { HTMLElement, parse } from 'node-html-parser'
import { FunctionalComponent } from 'preact'

interface StringToHtmlProps {
  htmlString: string
}

// This function was originally written for Camy ( https://github.com/BonnierNews/dn-sajt/ )
export const StringToHtml: FunctionalComponent<StringToHtmlProps> = ({ htmlString }) => {
  const root = parse(htmlString.trim())
  const outer = root.firstChild
  if (!outer || typeof outer === 'string' || !(outer instanceof HTMLElement)) {
    return null
  }

  const tagName = outer.tagName.toLowerCase()
  const attributes = outer.attributes
  const innerHTML = outer.innerHTML

  // Convert attributes object to props for Preact
  const props: { [key: string]: string } = {}
  for (const [key, value] of Object.entries(attributes)) {
    props[key] = String(value)
  }

  const Tag = tagName as any
  return <Tag {...props} dangerouslySetInnerHTML={{ __html: innerHTML }} />
}
